import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { useNewCapability } from 'sharedHooks';
import { ErrorBoundary } from 'sharedComponents/ErrorBoundary';
import { AssetLabels } from './AssetLabels';
import { AssetNameplateImageHolder } from './AssetNameplateImageHolder';

import { AssetPhysicalConnection } from './AssetPhysicalConnection';
import { triggerReportIssueDialog } from '../../../../PowertrainOverview/actions';
import './style.scss';

const HeaderComponent = (props) => {

    const capability = useNewCapability();
    const dispatch = useDispatch();

    const handleReportIssue = () => {
        dispatch(triggerReportIssueDialog());
    };

    return (
        <Col className='header-container' md={12}>
            {capability.hasLabelingCapability() && <Row><AssetLabels asset={props.asset} /></Row>}
            <div className='asset-conditions'>
                <AssetNameplateImageHolder asset={props.asset} />
            </div>
            <div className='asset-physical-connection' id='asset-physical-connection'>
                <ErrorBoundary onReportIssue={handleReportIssue}>
                    <AssetPhysicalConnection asset={props.asset} />
                </ErrorBoundary>
            </div>
        </Col>
    );
};

HeaderComponent.propTypes = {
    asset: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default HeaderComponent;
